/**
 * SUB-A4: deep-link targets + copy for the app-store subscription status
 * panel (Settings -> Subscription) and the matching per-card manage button.
 *
 * Neither `/subscription/packages/active/` (SubscriptionPackageSerializer,
 * Backend/subscription/serializers.py:304-323) nor the profile serializer
 * (`UserProfileSerializer.get_is_subscription_from_web`,
 * Backend/home/api/v1/serializers.py:1382) expose the raw purchase platform
 * to the client today -- only the derived `is_subscription_from_web`
 * boolean (true/false/null). `ActiveSubscription.payment_source` (the real
 * apple_iap/google_play/web/stripe value) exists on the model but is never
 * serialized out to any endpoint the FE calls -- `ActiveSubscriptionSerializer`
 * exists in that same file but has zero callers. So `paymentSource` below is
 * read defensively (undefined today) so a BE twin that adds the real value
 * to one of those two responses needs no FE change beyond passing it
 * through -- see the PR body for the requested BE follow-up.
 */

export const APPLE_APP_STORE_SUBSCRIPTIONS_URL =
  "https://apps.apple.com/account/subscriptions";
export const GOOGLE_PLAY_SUBSCRIPTIONS_URL =
  "https://play.google.com/store/account/subscriptions";

export const resolveAppStoreManagement = (paymentSource) => {
  if (paymentSource === "apple_iap") {
    return {
      label: "Managed by App Store",
      links: [
        { text: "Manage on App Store", href: APPLE_APP_STORE_SUBSCRIPTIONS_URL },
      ],
    };
  }
  if (paymentSource === "google_play") {
    return {
      label: "Managed by Google Play",
      links: [
        { text: "Manage on Google Play", href: GOOGLE_PLAY_SUBSCRIPTIONS_URL },
      ],
    };
  }
  // Unknown store (the current live API shape): neutral label, both links.
  return {
    label: "Managed in your app store",
    links: [
      { text: "Manage on App Store", href: APPLE_APP_STORE_SUBSCRIPTIONS_URL },
      { text: "Manage on Google Play", href: GOOGLE_PLAY_SUBSCRIPTIONS_URL },
    ],
  };
};
